module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-2af0c306"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/DateRange.vue
// module id = 964
// module chunks = 0